module.exports = __webpack_public_path__ + "img/admin.a9e907b4.svg";